import TabList from '@mui/lab/TabList/TabList';
import { Box, Tab, useTheme } from '@mui/material';
import { tabContainerSx, tabListSx, tabSx } from './NavTabBar.style';

export const NavTabBar = ({ handleChange, ariaLabel, tabs }) => {
  const theme = useTheme();

  return (
    <Box component="nav" sx={tabContainerSx(theme)}>
      <TabList
        onChange={handleChange}
        aria-label={ariaLabel}
        textColor="secondary"
        sx={tabListSx(theme)}
      >
        {tabs.map((t, i) => (
          <Tab key={i} label={t} value={(i + 1).toString()} sx={tabSx(theme)} />
        ))}
      </TabList>
    </Box>
  );
};
